export enum ApplyViewMode {
  Modal = 'modal',
  Page = 'page',
}
